// src/redux/slices/testimonialSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

// Fetch testimonials for public display
export const fetchTestimonials = createAsyncThunk(
  'testimonials/fetchTestimonials',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get('/testimonials');
      return res.data.testimonials;
    } catch (err) {
      return rejectWithValue('Error fetching testimonials');
    }
  }
);

// Add testimonial from public form
export const addTestimonial = createAsyncThunk(
  'testimonials/addTestimonial',
  async (testimonial, { rejectWithValue }) => {
    try {
      const res = await api.post('/testimonials', testimonial);
      return res.data.testimonial;
    } catch (err) {
      return rejectWithValue('Error adding testimonial');
    }
  }
);

const testimonialSlice = createSlice({
  name: 'testimonials',
  initialState: {
    testimonials: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTestimonials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTestimonials.fulfilled, (state, action) => {
        state.loading = false;
        state.testimonials = action.payload;
      })
      .addCase(fetchTestimonials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addTestimonial.fulfilled, (state, action) => {
        state.testimonials.unshift(action.payload);
      });
  },
});

export default testimonialSlice.reducer;

// Public testimonial selectors
export const selectTestimonials = state => state.testimonials.testimonials;
export const selectTestimonialsLoading = state => state.testimonials.loading;
